Monitoring.Views.SocialContents ||= {}


class Monitoring.Views.SocialContents.RealtimeContentCheckerView extends Backbone.View
  template: JST["backbone/templates/monitoring/realtime/realtime_content_available"]

  events :
    'click #add_realtime_content': 'onAddRealtimeContent'

  initialize: (@options = {}) ->
    @dashboardUuid = @options.uuid

  onAddRealtimeContent: =>
    @clearTimeout()
    @eventAggregator.bind('contentReceived', @onContentReceived)
    @eventAggregator.trigger('searchRealtimeContent', @dashboardUuid)

  onContentReceived: =>
    @eventAggregator.unbind('contentReceived', @onContentReceived)
    @restartTimeOut()

  notifyNewContent: (counter) =>
    if (counter > 0)
      if (counter == 100)
        @$el.find('#counter').html("#{counter}+")
      else
        @$el.find('#counter').html(counter)
      @show()
      @eventAggregator.trigger('onNewRealtimeContent', @dashboardUuid, counter)

  poll: ->
    if !@timeOutWasCleared and window.environment != 'development'
      @pollTimeout = setTimeout =>
        @updateIfIsNeeded()
      , @getTimeToWait()

  clearTimeout: ->
    @timeOutWasCleared = true
    clearTimeout(@pollTimeout)

  restartTimeOut: ->
    @timeOutWasCleared = false
    @poll()

  render: ->
    @$el.html(@template())
    @hide()
    @restartTimeOut()
    return this

  hide: ->
    @$el.hide()

  show: ->
    @$el.show()

  destroy: ->
    @clearTimeout()
    @remove()

  getMinutesToWait: ->
    2

  getTimeToWait: ->
    @getMinutesToWait() * 60 * 1000

  updateIfIsNeeded: ->
    if @shouldUpdate()
      $.ajax
        url: "/monitoring/dashboard/realtime_count/"
        type: 'POST'
        data:
          uuid: @dashboardUuid
        global: false
        success: (data) =>
          @notifyNewContent(data.counters.enqueued_count)
        complete: () =>
          if !@timeOutWasCleared
            @poll()
        dataType: "json"
    else
      @poll()

  shouldUpdate: ->
    true